import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Button from "@mui/material/Button";

export default function supportRequestsTableData({ requestList = [], onView }) {
  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "Subject", accessor: "subject", width: "30%", align: "left" },
      { Header: "Submitted", accessor: "submittedAt", align: "left" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: requestList.map((request) => ({
      name: (
        <MDTypography variant="button" fontWeight="medium">
          {request?.name}
        </MDTypography>
      ),
      email: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {request?.email}
        </MDTypography>
      ),
      subject: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {request?.subject}
        </MDTypography>
      ),
      submittedAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {request?.submittedAt}
        </MDTypography>
      ),
      status: (
        <MDBadge
          badgeContent={request?.status}
          color={request?.status === "replied" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onView(request)}>
            View
          </Button>
        </MDBox>
      ),
    })),
  };
}
